<ng-container *ngIf="!isLoading && !hasError; else loadingOrError">
  <ng-container *ngIf="catalog; else noCatalog">

    <div class="catalog-logo" *ngIf="catalog?.thumbUri">
      <img [src]="catalog.thumbUri" alt="Katalog" class="catalog-logo-img" />
    </div>

    <dx-tab-panel
      [animationEnabled]="true"
      [swipeEnabled]="false"
      iconPosition="start"
      stylingMode="primary"
      width="100%"
      height="100%">

      <dxi-item [title]="'Katalog' | translate">
        <div *dxTemplate>
          <div class="inspect-content p-2">

              <div class="context-row">
                  <div class="context-label">{{ 'Letzte Änderung' | translate }}</div>
                  <div class="context-value">
                      {{ container?.lastChanged ? (container.lastChanged | date:'short') : 'n/b' }}
                  </div>
                  <div class="context-actions"></div>
              </div>
              
              
              <div class="context-row">
                  <div class="context-label">{{ 'Importiert' | translate }}</div>
                  <div class="context-value">{{ catalog?.date }}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">{{ 'Kategorien' | translate }}</div>
                  <div class="context-value">{{ catalog?.categoryCount }}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">{{ 'Produkte' | translate }}</div>
                  <div class="context-value">{{ catalog?.productCount}}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">🔴 {{ 'Gelöscht' | translate }}</div>
                  <div class="context-value">{{ comparisonCounts?.geloescht || 0 }}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">🟡 {{ 'Geändert' | translate }}</div>
                  <div class="context-value">{{ comparisonCounts?.geaendert || 0 }}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">🟢 {{ 'Neu' | translate }}</div>
                  <div class="context-value">{{ comparisonCounts?.neu || 0 }}</div>
              </div>

              <div class="context-row">
                  <div class="context-label">{{ 'Verantwortlich' | translate }}</div>
                  <div class="context-value">{{ catalog?.responsible }}</div>
              </div>

              <div class="context-row catalog-note-row" *ngIf="container">
                 <div class="context-label"><b> {{ 'Container Notiz' | translate }} </b> </div>
                  <div class="catalog-note-box">
              <dx-text-area
              [(value)]="container.note"
              (onFocusOut)="saveContainerNote($event)">
              </dx-text-area>
              </div>
              </div>
          </div>

          <np-container-catalog-edit
            [(visible)]="editVisible"
            [catalog]="catalog"
            [popupTitle]="'Katalog bearbeiten' | translate"
            (saved)="onMetadataSaved($event)"
            (canceled)="onMetadataCanceled()">
          </np-container-catalog-edit>

        </div>
      </dxi-item>

      <dxi-item [title]="'Datenqualität' | translate">
        <div *dxTemplate>
          <div class="data-quality-tab-content">
            <dataQuality *ngIf="catalog"></dataQuality>
          </div>
        </div>
      </dxi-item>

      <dxi-item [title]="'Medien' | translate">
        <div *dxTemplate>
          <div class="media-tab-content">
            <mediaPool *ngIf="catalog"></mediaPool>
          </div>
        </div>
      </dxi-item>

      <dxi-item [title]="'Jobs' | translate">
        <div *dxTemplate>
          <div class="jobs-tab-content">
            <job-list *ngIf="jobsKey"
                      [storeName]="'JobListStateNewUI_V4_CONTAINERINSPECT'"
                      [jobListMode]="false"
                      [catalogMode]="true"
                      [adminMode]="false"
                      [compactMode]="true">
            </job-list>
          </div>
        </div>
      </dxi-item>

      <dxi-item *ngIf="showContainerTab" [title]="'Container' | translate">
        <div *dxTemplate>
          <div class="inspect-content p-2">

            <div class="context-row">
              <div class="context-label">{{ 'Letzte Änderung' | translate }}</div>
              <div class="context-value">
                {{ container?.lastChanged ? (container.lastChanged | date:'short') : 'n/b' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Typ' | translate }}</div>
              <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Letzter importierter Katalog' | translate }}</div>
              <div class="context-value">{{ lastImportedCatalogName || 'n/b' }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Kataloge' | translate }}</div>
              <div class="context-value">{{ container?.catalogIds?.length || 0 }}</div>
            </div>

            <div class="context-row context-top">
              <div class="context-label">{{ 'Verantwortlich' | translate }}</div>
              <div class="context-value">
                <div *ngIf="dataSource?.contactPerson">{{ dataSource.contactPerson }}</div>
                <div *ngIf="dataSource?.supportTel" class="container-meta-secondary">{{ dataSource.supportTel }}</div>
                <a *ngIf="dataSource?.supportMail"
                   [href]="'mailto:' + dataSource.supportMail"
                   class="container-meta-mail">{{ dataSource.supportMail }}</a>
                <span *ngIf="!dataSource?.contactPerson && !dataSource?.supportTel && !dataSource?.supportMail">n/b</span>
              </div>
            </div>

            <div class="container-notes-block">
              <div class="context-label">{{ 'Notizen' | translate }}</div>
              <div class="container-notes-box">{{ container?.note || '' }}</div>
            </div>

          </div>
        </div>
      </dxi-item>

    </dx-tab-panel>
  </ng-container>
</ng-container>

<ng-template #loadingOrError>
  <div class="p-3 text-muted" *ngIf="isLoading">
    {{ 'Lade Katalog …' | translate }}
  </div>
  <div class="p-3 text-danger" *ngIf="!isLoading && hasError">
    {{ 'Katalog konnte nicht geladen werden.' | translate }}
  </div>
</ng-template>

<ng-template #noCatalog>
  <div class="p-3 text-muted">
    {{ 'Kein Katalog ausgewählt.' | translate }}
  </div>
</ng-template>
